import React, { FC } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import { GradientButton } from "components/GradientButton";
import { Link } from "react-router-dom";
import { routesEnum } from "pages/Routes";

const CardExplore: FC = () => {
  return (
    <div className={clsx(styles.cardExplore, styles.card)}>
      <img src="/images/landing/explore_icon.svg" />

      <h3>Explore hackathons</h3>
      <p>
        Find hackathons you wish to join & projects you can fail in love with
      </p>
      <Link to={routesEnum.home}>
        <GradientButton>Explore hackathons</GradientButton>
      </Link>
    </div>
  );
};

export default CardExplore;
